import * as Yup from "yup";
import "../../../utils/validators";
import { isSameDateSafe } from "../../../utils/dates";

export const validationSchemaSendDate = ({
  isDraft,
  originalDate
}: {
  isDraft: boolean;
  originalDate?: Date;
}) =>
  Yup.date().when("type", {
    is: "date",
    then: Yup.lazy((value: Date | undefined) => {
      const schema = Yup.date()
        .typeError("Enter a valid send date")
        .required("Send date is required");

      return !isDraft && isSameDateSafe(value, originalDate)
        ? schema
        : schema.isTodayAndInFuture();
    })
  });
